export default "__VITE_ASSET__DCfAEmSA__"